import { OAUTH_TOKEN_SUCCESS, OAUTH_REFRESH_SUCCESS, OAUTH_TOKEN_REFRESH_FAILURE } from "../../actions/oauth";

import OAuthHandler from "../../lib/OAuthHandler";

const oAuthMiddleware = store => {
  const oAuthHandler = new OAuthHandler(store);
  return next => async action => {
    let skipAction = false;
    if (action.type === OAUTH_TOKEN_SUCCESS) {
      oAuthHandler.storeTokenData(action.payload, false);
      skipAction = true;
    }
    if (action.type === OAUTH_REFRESH_SUCCESS) {
      oAuthHandler.storeTokenData(action.payload, false);
    }
    if (action.type === OAUTH_TOKEN_REFRESH_FAILURE) {
      const message = store.getState().ui.translate.authorizationError.replace("{0}", "10");
      // eslint-disable-next-line no-new
      new Notification(message);
    }
    if (!skipAction) next(action);
  };
};

export default oAuthMiddleware;
